import {SVGProps} from "react";

export const WarningSvg = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M17.9387 15.4167L10.7218 2.91667C10.4011 2.36111 9.59919 2.36111 9.27844 2.91667L2.06156 15.4167C1.74081 15.9722 2.14175 16.6667 2.78325 16.6667H17.217C17.8585 16.6667 18.2594 15.9722 17.9387 15.4167Z"
                stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M10.8334 13.3333C10.8334 13.7936 10.4603 14.1667 10 14.1667C9.53978 14.1667 9.16669 13.7936 9.16669 13.3333C9.16669 12.8731 9.53978 12.5 10 12.5C10.4603 12.5 10.8334 12.8731 10.8334 13.3333Z"
                fill="currentColor"/>
            <path d="M10 10.833L10 7.49967" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}
